export const RECEIVING_MATERIAL_DOCUMENT_REGEX = /^SR\d{8}$/;
export const EXPORT_REGEX = /^XH\d{8}$/;
export const EXPORT_RETURN_REGEX = /^RD\d{8}$/;
export const SPLIT_REGEX = /^CH\d{8}$/;
export const PREPARE_NOTE_REGEX = /^SH\d{8}$/;
export const DELIVERY_REGEX = /^GH\d{8}$/;
export const PALLET_BARCODE_REGEX = /^P[A-Z][0-9]\d\d{2}\d{5}$/; //P
export const CARTON_BARCODE_REGEX = /^\d{6}\w\d{2}C\d{3}$/; //C
export const CARTON_BARCODE2_REGEX = /^SH\d{8}C\d{3}$/; //K
export const CARTON_BARCODE3_REGEX = /\d{6}\w\d{2}(C|c)\w{3}$/;
export const CARTON_BARCODE_TEMP_REGEX = /^DO\d{8}C\d{3}$/;
export const PRODUCT_CARTON_REGEX = /^\d{6}\w\d{2}\d{5}/;
export const TRUCK_NO_REGEX = /^SX_.*$/;
export const EMPLOYEE_REGEX = /^KH_/;
export const PRODUCT_REGEX = /^\d{6}\w\d{2}\d{5}/;
export const PRODUCT2_REGEX = /^NV_/;
export const CUSTOMER_REGEX = /\w{10}/;
export const PRODUCT3_REGEX = /\w{26}/;
export const PRODUCT_LOT_REGEX = /^\d{6}\w\d{2}$/;
export const PRODUCT_LOT4_REGEX = /^\d{6}\w\d{2}-\d{3}$/;
export const PRODUCT_LOT2_REGEX = /^\d*\d{8}\w\d{6}$/;
export const PRODUCT_LOT3_REGEX = /^\d*\d{8}\w\d{12}$/;
export const LOCATION_CODE_REGEX = /^\w{3}_\w{2}_\w{2}\d-\d\d$/;
export const ACCESS_CODE_REGEX = /^\d{4}$/;

export const isCarton = (barcode: string) => {
  return (
    CARTON_BARCODE_REGEX.test(barcode) ||
    CARTON_BARCODE2_REGEX.test(barcode) ||
    CARTON_BARCODE3_REGEX.test(barcode) ||
    PRODUCT_CARTON_REGEX.test(barcode)
  );
};
export const isInventory = (barcode: string) => {
  return (
    PRODUCT_REGEX.test(barcode) ||
    PRODUCT2_REGEX.test(barcode) ||
    PRODUCT3_REGEX.test(barcode)
  );
};
export const isProductLot = (barcode: string) => {
  return PRODUCT_LOT_REGEX.test(barcode);
};
export const isPallet = (barcode: string) => {
  return PALLET_BARCODE_REGEX.test(barcode);
};

export const isEncryptedBarcode = (barcode: string) => {
  return barcode.includes("==");
};
